<template>
  <div class="AddTagAttributeModal">
    <el-dialog
      title="新增标签分类"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="属性名称" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "AddTagAttributeModal",
  data() {
    return {
      form: {
        id: null,
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入标签分类名称",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[\s\S]{0,8}$/,
            message: "不得超过8个文字",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("teachingCenter", ["tagCategoryList", "rowDetails"]),
    visible: {
      get() {
        return this.$store.state.teachingCenter.addTagAttributeVisible;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "addTagAttributeVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapActions("teachingCenter", ["saveTagCategory", "getTagCategoryList"]),
    ...mapMutations("teachingCenter", ["setData"]),
    // 确定添加
    async handleConfirm() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveTagCategory({
            ...this.form,
          });
          await this.getTagCategoryList({
            page: this.tagCategoryList.page,
            size: this.tagCategoryList.size,
          });
          if (this.form.id) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("添加成功");
          }
          this.setData({
            key: "addTagAttributeVisible",
            value: false,
          });
        }
      });
    },
    clearForm() {
      Object.keys(this.form).map((key) => {
        this.form[key] = null;
      });
    },
    handleOpen() {
      this.clearForm();
      Object.keys(this.form).map((key) => {
        this.form[key] = this.rowDetails[key];
      });
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AddTagAttributeModal {
}
</style>
